import { createContext } from 'react';
const OperatorContext = createContext(null);
export default OperatorContext;
